import { Box } from '@chakra-ui/react'
import CommunityTable from './components/CommunityTable'

export default function User () {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <CommunityTable />
    </Box>
  )
}

//TODO: fix the photo display and update functionality in the modal!